import { PointType } from './pointtype.enum';
import { ILocation, Location } from './location';
import { IDispatchPoint, DispatchPoint } from './dispatchpoint';
import { Direction } from './direction.enum';

export class ReportBy {
    type: PointType;
    displayName: string;
    dispatchPoint: DispatchPoint;
    dispatchablePoint: string;
    location: Location;
    direction: Direction;

    constructor(reportBy?: ReportBy) {
        this.type = reportBy.type;
        this.displayName = reportBy.displayName;
        this.dispatchPoint = reportBy.dispatchPoint === undefined ? undefined : new DispatchPoint(reportBy.dispatchPoint);
        this.dispatchablePoint = reportBy.dispatchablePoint;
        this.location = new Location(reportBy.location);
        this.direction=reportBy.direction;
    }
}